import React from 'react';
import FormButtonContainer from './FormButtonContainer';

export default (props) => {
    return <FormButtonContainer lang={props.lang} selectedChallenge={props.selectedChallenge} isChecked={props.isChecked} />
}


// WEBPACK FOOTER //
// ./src/components/formButton/index.jsx